import React, {
  useState, useEffect, useRef
} from "react";
import Link from "next/link";
import { useRouter } from "next/dist/client/router";

function secondNav(props) {
  const router = useRouter()
  const [dropdown, setDropdown] = useState(false);
  const handlerDropdown = () => {

    setDropdown((dropdown) => !dropdown);
    // if (dropdown == true) {
    //   router.push("/weight_loss/medication")
    // }
  };
  const handlerDropdown_hide = () => {
    setDropdown(!dropdown)
  }
  const divRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setDropdown(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);
  return (
    <div className=" htw-second-nav gapping-div custom-navbar ">
    </div>
  );
}

export default secondNav;
